export const environment = {
  production: true,
  sentry: 'https://739e08d83e84dd1f6bf84e572b2d7d28@o446789.ingest.us.sentry.io/4509591812833280',
  name: 'Production',
  baseUrl: 'https://prod.crowndesk.be',
  apiUrl: 'https://prod.crowndesk.be/api',
  auth0: {
    domain: 'royalcrown.eu.auth0.com',
    clientId: 'ITj9hGe4b3MQPs03jQSaQ7Y419t488hB',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://prod.api.royalcrown.be/',
      logoutUrl: window.location.origin,
    },
    useRefreshTokens: true,
    httpInterceptor: {
      allowedList: [
        {
          // Match any request that starts 'https://{yourDomain}/api/v2/' (note the asterisk)
          uri: `https://prod.crowndesk.be/api/*`,
          tokenOptions: {
            authorizationParams: {
              // The attached token should target this audience
              audience: 'https://prod.api.royalcrown.be/',
              scope: 'openid profile email offline_access',
            },
          },
        },
      ],
    },
  },
};
